import { FC, useState } from "react";
import Link from "next/link";
import Icon from "newComponents/Shared/_Atoms/Icons/Icon/Icon";

interface IProps {
  item: Menu;
  activeLink: string;
  brandingColor: string;
  onClick: () => void;
}

export const MenuItem: FC<IProps> = ({ item, activeLink, brandingColor, onClick }) => {
  const [isHovered, setIsHovered] = useState(false);
  const activeItem = activeLink === item.value;
  const content = (
    <li
      className="menu-item"
      style={{ backgroundColor: (activeItem || isHovered) && "#fff" }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClick}
      id={item.value}
    >
      <Icon
        icon={item.icon}
        className="menu-icon"
        style={{ color: (activeItem || isHovered) && brandingColor }}
      />
      <p className="menu-label" style={{ color: (activeItem || isHovered) && brandingColor }}>
        {item.label}
      </p>
    </li>
  );

  return item.label === "Help" ? (
    <a
      target="_blank"
      href="https://instructor.support.myprepcourse.com"
      className="menu-item--additional"
    >
      {content}
    </a>
  ) : (
    <Link href={`/${item.value}`} key={item.value}>
      {content}
    </Link>
  );
};
